import { Controller } from '@hotwired/stimulus';
import { application } from 'src';
import { find, removeClass, addClass, getParent } from '@fretadao/f-js-dom';

application.register('routing-request-schedules-form', class extends Controller {
  static targets = ['tripKindField', 'arrivalField', 'departureField'];

  connect() {
    this.loadByTripKind();
  }

  loadByTripKind() {
    if(this.hasArrivalFieldTarget && ['roundtrip', 'ingoing'].includes(this.tripKindFieldTarget.value)) {
      this.#applyEditRule(this.arrivalFieldTarget);
    }
    if(this.hasDepartureFieldTarget && ['roundtrip', 'outgoing'].includes(this.tripKindFieldTarget.value)) {
      this.#applyEditRule(this.departureFieldTarget);
    }
  }

  #applyEditRule(targetField) {
    const selectField = targetField;

    if(selectField?.type !== 'select-one') return;

    const editLink = this.#editLink();
    const divParent = getParent(selectField, 2);

    addClass(divParent, ['flex', 'space-x-2', 'items-center']);
    addClass(find('.Form-inputGroup'), 'grow');

    if(!find('a', divParent)) divParent.append(editLink);

    editLink.addEventListener('click', () => {
      if(selectField.disabled) return;

      selectField.remove();
      editLink.remove();

      removeClass(divParent, ['flex', 'space-x-2']);
      divParent.append(this.#inputField(selectField));
    });
  };

  #editLink() {
    const editLink = document.createElement('a');
    editLink.textContent = 'Editar';
    addClass(editLink, ['w-14', 'mt-3.5']);
    return editLink;
  }

  #inputField(selectField) {
    const inputField = document.createElement('input');
    addClass(inputField, ['Form-input', 'w-full']);
    inputField.type = 'time';
    inputField.value = selectField.value;
    inputField.required = true;
    inputField.name = selectField.name;
    inputField.id = selectField.id;
    inputField.dataset.formValidatorTarget = 'validation';
    inputField.dataset.dependantToggleTarget = selectField.dataset.dependantToggleTarget;
    return inputField;
  }
});
